/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { StoreManagementListSaleResponse } from './StoreManagementListSaleResponse';

export type StoreManagementListSaleResponseApiRespoonse = {
    data?: StoreManagementListSaleResponse;
    status?: StoreManagementListSaleResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace StoreManagementListSaleResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

